/* eslint-disable */
/*
https://stackblitz.com/edit/react-krffm4
https://stackoverflow.com/questions/54904484/unable-to-add-leaflet-geosearch-to-react-application
*/

import { Component } from "react";
import L from "leaflet";
import * as ELG from "esri-leaflet-geocoder"
import LCG from 'leaflet-control-geocoder';;
import { withLeaflet } from "react-leaflet";

class Search extends Component {

  state = {
    lat:'',
    lng:'',
    label: ''
  }

  componentDidMount() {

    const map = this.props.leaflet.map;
    const searchControl = new ELG.Geosearch().addTo(map);
    const results = new L.LayerGroup().addTo(map);
    const geocoder = L.Control.Geocoder.nominatim();

    searchControl.on("results", async (data) => {
      results.clearLayers();
      for (let i = data.results.length - 1; i >= 0; i--) {

        // http://bl.ocks.org/ramiroaznar/f399ffd29d1b4d48632604aebfc7b8cc

        var myMarker =L.marker(data.results[i].latlng, 
          {
            draggable: true,
            title: 'Your Moramma Spot'
          },)
          .bindPopup("<b>Spot</b><br>Your Moramma Spot")
          .openPopup()
        .on('dragend', async () => {
        //  var coord = String(myMarker.getLatLng()).split(',');
          //console.log();
          this.props.link(`lat: ${Number(myMarker._latlng.lat).toFixed(3)}, long: ${Number(myMarker._latlng.lng).toFixed(3)}`,this.state.label, myMarker._latlng.lat, myMarker._latlng.lng);

          geocoder.reverse(myMarker._latlng, map.options.crs.scale(map.getZoom()), results => {
            //var r = results[0];
            console.log('res', results)
          });
        /*  await this.setStateAsync({
            lat: myMarker._latlng.lat, 
            lng: myMarker._latlng.lng
          });
*/
       //   var lat = coord[0].split('(');
        //  console.log(lat);
        //  var lng = coord[1].split(')');
        //  console.log(lng);
       //   myMarker.bindPopup("Moved to: " + lat[1] + ", " + lng[0] + ".");
        });


        results.addLayer(myMarker);

        await this.setStateAsync({
          lat: data.results[i].latlng["lat"], 
          lng: data.results[i].latlng["lng"],
          label: data.results[i].properties.LongLabel
        });

        this.props.link(`lat: ${Number(this.state.lat).toFixed(3)}, long: ${Number(this.state.lng).toFixed(3)}`,this.state.label,this.state.lat, this.state.lng);
      }
    });
  }

  render() {
    return null;
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve)
    });
}
}

//export default Search;
export default withLeaflet(Search);

